(function ($) {
    "use strict";
    let counter = 5;
    const btn = document.getElementById("backBtnHomeEmail");
    if (btn) {
        const interval = setInterval(() => {
            counter--;

            btn.textContent = `Go Back to Homepage (${counter}s)`;

            if (counter <= 0) {
                clearInterval(interval);
                window.location.href = "/";
            }
        }, 1000);

    }

    if ($(".scroll-to-target").length) {
        $(".scroll-to-target").on("click", function () {
            var target = $(this).attr("data-target");
            // animate
            $("html, body").animate(
                {
                    scrollTop: $(target).offset().top
                },
                1000
            );

            return false;
        });
    }

    if ($(".contact-form-validated").length) {
        $(".contact-form-validated").validate({
            // initialize the plugin
            rules: {
                name: {
                    required: true,
                    minlength: 2
                },
                email: {
                    required: true,
                    email: true,
                },
                message: {
                    required: true,
                    minlength: 10
                },
                subject: {
                    required: true,
                    minlength: 3
                }
            },
            messages: {
                name: {
                    required: "Please enter your full name.",
                    minlength: "Your name must be at least 2 characters long."
                },
                email: {
                    required: "Please enter your email address.",
                    email: "Please enter a valid email address.",
                    pattern: "Please enter a valid email format — example: name@example.com"
                },
                message: {
                    required: "Please enter your message.",
                    minlength: "Your message must be at least 10 characters."
                },
                subject: {
                    required: "Please enter a subject.",
                    minlength: "The subject should be at least 3 characters long."
                }
            },
            submitHandler: function (form) {
                // sending value with ajax request
                $.post($(form).attr("action"), $(form).serialize())
                .done(function (response) {
                    // SUCCESS
                    $(form).parent().find(".result").html(response);
                    $(form).trigger("reset");
                    window.location.href = "/thank-your-for-contact";
                }).fail(function (xhr, status, error) {
                    window.location.href = "/error-email";
                }); 
                return false;
            }
        });
    }
    if ($(".contact-form-validated-001").length) {
        $(".contact-form-validated-001").validate({
            // initialize the plugin
            rules: {
                name: {
                    required: true,
                    minlength: 2
                },
                email: {
                    required: true,
                    email: true,
                },
                dob: {
                    required: true
                },
                address: {
                    required: true,
                    minlength: 3
                },
                occupation: {
                    required: true,
                    minlength: 3
                },
                message: {
                    required: true,
                    minlength: 10
                }
            },

            messages: {
                name: {
                    required: "Please enter your full name.",
                    minlength: "Your name must be at least 2 characters long."
                },
                email: {
                    required: "Please enter your email address.",
                    email: "Please enter a valid email address.",
                    pattern: "Please enter a valid professional email address."
                },
                dob: {
                    required: "Please select your date of birth."
                },
                address: {
                    required: "Please enter your address.",
                    minlength: "Address must be at least 3 characters long."
                },
                occupation: {
                    required: "Please enter your occupation.",
                    minlength: "Occupation must be at least 3 characters long."
                },
                message: {
                    required: "Please enter your message.",
                    minlength: "Message must be at least 10 characters long."
                }
            },

            submitHandler: function (form) {
                // sending value with ajax request
                $.post($(form).attr("action"), $(form).serialize()).done(function (response) {
                    // SUCCESS
                    $(form).parent().find(".result").html(response);
                    $(form).trigger("reset");
                    window.location.href = "/thank-your-for-contact";
                }).fail(function (xhr, status, error) {
                    window.location.href = "/error-email";
                }); 
                return false;
            }
        });
    }

    // mailchimp form
    if ($(".mc-form").length) {
        $(".mc-form").each(function () {
            var Self = $(this);
            var mcURL = Self.data("url");
            var mcResp = Self.parent().find(".mc-form__response");

            Self.ajaxChimp({
                url: mcURL,
                callback: function (resp) {
                    // appending response
                    mcResp.append(function () {
                        return '<p class="mc-message">' + resp.msg + "</p>";
                    });
                    // making things based on response
                    if (resp.result === "success") {
                        // Do stuff
                        Self.removeClass("errored").addClass("successed");
                        mcResp.removeClass("errored").addClass("successed");
                        Self.find("input").val("");

                        mcResp.find("p").fadeOut(10000);
                    }
                    if (resp.result === "error") {
                        Self.removeClass("successed").addClass("errored");
                        mcResp.removeClass("successed").addClass("errored");
                        Self.find("input").val("");

                        mcResp.find("p").fadeOut(10000);
                    }
                }
            });
        });
    }

    if ($(".video-popup").length) {
        $(".video-popup").magnificPopup({
            disableOn: 700,
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: true,

            fixedContentPos: false
        });
    }

    if ($(".img-popup").length) {
        var groups = {};
        $(".img-popup").each(function () {
            var id = parseInt($(this).attr("data-group"), 10);

            if (!groups[id]) {
                groups[id] = [];
            }

            groups[id].push(this);
        });

        $.each(groups, function () {
            $(this).magnificPopup({
                type: "image",
                closeOnContentClick: true,
                closeBtnInside: false,
                gallery: {
                    enabled: true
                }
            });
        });
    }

    function dynamicCurrentMenuClass(selector) {
        let FileName = "/" + window.location.href.split("/").reverse()[0];

        selector.find("li").each(function () {
            let anchor = $(this).find("a");
            if ($(anchor).attr("href") == FileName) {
                $(this).addClass("current");
            }
        });
        // if any li has .current elmnt add class
        selector.children("li").each(function () {
            if ($(this).find(".current").length) {
                $(this).addClass("current");
            }
        });
        // if no file name return
        if ("" == FileName) {
            selector.find("li").eq(0).addClass("current");
        }
    }
    if ($(".main-menu__list").length) {
        // dynamic current class
        let mainNavUL = $(".main-menu__list");
        dynamicCurrentMenuClass(mainNavUL);
    }

    if ($(".mobile-nav__container").length) {
        let navContent = document.querySelector(".main-menu").innerHTML;
        let mobileNavContainer = document.querySelector(".mobile-nav__container");
        mobileNavContainer.innerHTML = navContent;
    }
    if ($(".sticky-header__content").length) {
        let navContent = document.querySelector(".main-menu").innerHTML;
        let mobileNavContainer = document.querySelector(".sticky-header__content");
        mobileNavContainer.innerHTML = navContent;
    }

    if ($(".mobile-nav__container .main-menu__list").length) {
        let dropdownAnchor = $(
            ".mobile-nav__container .main-menu__list .dropdown > a"
        );
        dropdownAnchor.each(function () {
            let self = $(this);
            let toggleBtn = document.createElement("BUTTON");
            toggleBtn.setAttribute("aria-label", "dropdown toggler");
            toggleBtn.innerHTML = "<i class='fa fa-angle-down'></i>";
            self.append(function () {
                return toggleBtn;
            });
            self.find("button").on("click", function (e) {
                e.preventDefault();
                let self = $(this);
                self.toggleClass("expanded");
                self.parent().toggleClass("expanded");
                self.parent().parent().children("ul").slideToggle();
            });
        });
    }

    if ($(".mobile-nav__toggler").length) {
        $(".mobile-nav__toggler").on("click", function (e) {
            e.preventDefault();
            $(".mobile-nav__wrapper").toggleClass("expanded");
        });
    }

    if ($(".search-toggler").length) {
        $(".search-toggler").on("click", function (e) {
            e.preventDefault();
            $(".search-popup").toggleClass("active");
        });
    }
    if ($(".odometer").length) {
        $(".odometer").appear(function (e) {
            var odo = $(".odometer");
            odo.each(function () {
                var countNumber = $(this).attr("data-count");
                $(this).html(countNumber);
            });
        });
    }

    if ($(".wow").length && typeof WOW !== 'undefined') {
        var wow = new WOW({
            boxClass: "wow", // animated element css class (default is wow)
            animateClass: "animated", // animation css class (default is animated)
            mobile: true, // trigger animations on mobile devices (default is true)
            live: true // act on asynchronously loaded content (default is true)
        });
        wow.init();
    }

    if ($("#donate-amount__predefined").length) {
        let donateInput = $("#donate-amount");
        $("#donate-amount__predefined")
            .find("li")
            .on("click", function (e) {
                e.preventDefault();
                let amount = $(this).find("a").text();
                donateInput.val(amount);
                $("#donate-amount__predefined").find("li").removeClass("active");
                $(this).addClass("active");
            });
    }

    $("#accordion .collapse").on("shown.bs.collapse", function () {
        $(this).prev().addClass("active");
    });

    $("#accordion .collapse").on("hidden.bs.collapse", function () {
        $(this).prev().removeClass("active");
    });

    $("#accordion").on("hide.bs.collapse show.bs.collapse", (e) => {
        $(e.target).prev().find("i:last-child").toggleClass("fa-plus fa-minus");
    });

    // window load event

    $(window).on("load", function () {
        if ($(".preloader").length) {
            $(".preloader").fadeOut();
        }
        // swiper slider

        const swiperElm = document.querySelectorAll(".thm-swiper__slider");

        swiperElm.forEach(function (swiperelm) {
            const swiperOptions = JSON.parse(swiperelm.dataset.swiperOptions);
            let thmSwiperSlider = new Swiper(swiperelm, swiperOptions);
        });

        if ($("#testimonials-two__thumb").length) {
            let testimonialsThumb = new Swiper("#testimonials-two__thumb", {
                slidesPerView: 3,
                spaceBetween: 0,
                speed: 1400,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                loop: true,
                autoplay: {
                    delay: 5000
                }
            });

            let testimonialsCarousel = new Swiper("#testimonials-two__carousel", {
                observer: true,
                observeParents: true,
                speed: 1400,
                mousewheel: true,
                slidesPerView: 1,
                autoplay: {
                    delay: 5000
                },
                thumbs: {
                    swiper: testimonialsThumb
                }
            });
        }

        // dynamic radius
        const dynamicRadius = document.querySelectorAll(".dynamic-radius");
        dynamicRadius.forEach(function (btn) {
            let btnHeight = btn.offsetHeight;
            btn.style.borderBottomLeftRadius = btnHeight / 2 + "px";
            btn.style.borderTopLeftRadius = btnHeight / 2 + "px";
        });
    });

    $(window).on("resize", function () {
        // dynamic radius
        const dynamicRadius = document.querySelectorAll(".dynamic-radius");
        dynamicRadius.forEach(function (btn) {
            let btnHeight = btn.offsetHeight;
            btn.style.borderBottomLeftRadius = btnHeight / 2 + "px";
            btn.style.borderTopLeftRadius = btnHeight / 2 + "px";
        });
    });

    // window load event

    $(window).on("scroll", function () {
        if ($(".stricked-menu").length) {
            var headerScrollPos = 130;
            var stricky = $(".stricked-menu");
            if ($(window).scrollTop() > headerScrollPos) {
                stricky.addClass("stricky-fixed");
            } else if ($(this).scrollTop() <= headerScrollPos) {
                stricky.removeClass("stricky-fixed");
            }
        }
    });
})(jQuery);